//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/Section.js";
let d=[[[1,"BaseDepth",0,"Expression",0],[1,"BaseDiameter",0,"Expression",0],[1,"BaseHeight",0,"Expression",0],[1,"BaseLowerDiameter",0,"Expression",0],[0,"BaseStyleEnum",1,0],[1,"BaseUpperDiameter",0,"Expression",0],[1,"BaseUserDefineSuperSection",0,"Section",0],[1,"BaseWidth",0,"Expression",0],[1,"ColumnDepth",0,"Expression",0],[1,"ColumnDiameter",0,"Expression",0],[1,"ColumnHeight",0,"Expression",0],[0,"ColumnOriginPoint",1,"Point",0],[0,"ColumnStyleEnum",1,0],[1,"ColumnThickness",0,"Expression",0],[1,"ColumnUserDefineSuperSection",0,"Section",0],[1,"ColumnWidth",0,"Expression",0],[0,"ShouldCopySketchBase",1,0],[0,"ShouldCopySketchColumn",1,0]],[],[]];
SPLM.LineDesigner.ColumnFeatureBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.ColumnFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.ColumnFeatureBuilder.ColumnType = Object.freeze({
    "IBeam" : "IBeam", "TBeam" : "TBeam", "Rectangle" : "Rectangle", "Circle" : "Circle", "UserDefine" : "UserDefine"});

SPLM.LineDesigner.ColumnFeatureBuilder.ColumnBaseType = Object.freeze({
    "None" : "None", "Rectangle" : "Rectangle", "Circle" : "Circle", "Cone" : "Cone", "UserDefined" : "UserDefined"});

export default SPLM;